/**
 * Main collection PLP — when no storefront filters are active: fetch full collection via products.json,
 * sort sold-out products to the end (collection-wide), paginate client-side (matches svc → ns → sold PLP order).
 */
(function () {
  var JSON_LIMIT = 250;
  var CACHE_PREFIX = 'skipp:plp-grid:v6:';
  var CACHE_TTL_MS = 5 * 60 * 1000;
  var MAX_CLIENT_FETCH_PRODUCTS = 2500;

  function shopBaseUrl() {
    var r =
      (typeof window !== 'undefined' && window.routes && window.routes.root_url) ||
      (typeof window !== 'undefined' &&
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '';
    r = String(r || '').trim();
    if (!r) {
      return typeof window !== 'undefined' ? window.location.origin + '/' : '/';
    }
    return r.endsWith('/') ? r : r + '/';
  }

  function collectionProductsJsonUrl(handle, limit, page, sortBy) {
    var path =
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      limit +
      '&page=' +
      page;
    if (sortBy) {
      path += '&sort_by=' + encodeURIComponent(sortBy);
    }
    var base = shopBaseUrl();
    try {
      return new URL(path, base).href;
    } catch (_e) {
      return path.indexOf('/') === 0 ? path : '/' + path;
    }
  }

  function tagArray(tags) {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags.map(function (t) { return String(t).toLowerCase().trim(); });
    return String(tags)
      .split(',')
      .map(function (t) { return t.toLowerCase().trim(); })
      .filter(Boolean);
  }

  function hasNotServiceableTag(product) {
    var t = tagArray(product.tags);
    return t.indexOf('not_serviceable') !== -1;
  }

  function toCents(v) {
    if (v == null || v === '') return 0;
    var s = String(v).trim();
    if (s.indexOf('.') !== -1) return Math.round(parseFloat(s) * 100);
    var n = parseInt(s, 10);
    return isNaN(n) ? 0 : n;
  }

  function formatRs(cents) {
    if (!cents) return '0';
    return String(Math.round(cents / 100)).replace(/\.00$/, '');
  }

  function variantIsPurchasable(v) {
    if (!v) return false;
    if (v.inventory_policy === 'continue') return true;
    var qty = v.inventory_quantity;
    if (qty != null && qty !== '' && Number(qty) > 0) return true;
    var a = v.available;
    if (a === true || a === 1) return true;
    if (typeof a === 'string') {
      var s = a.toLowerCase();
      if (s === 'true' || s === '1') return true;
      if (s === 'false' || s === '0') return false;
    }
    if (a === false || a === 0) return false;
    if (!v.inventory_management) return true;
    return false;
  }

  function productAvailable(p) {
    if (!p) return false;
    if (p.available === true || p.available === 1) return true;
    if (typeof p.available === 'string') {
      var a = p.available.toLowerCase();
      if (a === 'true' || a === '1') return true;
      if (a === 'false' || a === '0') return false;
    }
    if (p.available === false || p.available === 0) return false;
    var vs = p.variants || [];
    var i;
    for (i = 0; i < vs.length; i++) {
      if (variantIsPurchasable(vs[i])) return true;
    }
    return vs.length === 0;
  }

  function soldOutLabel() {
    var el = document.querySelector('script[type="application/json"][data-skipp-plp-i18n]');
    if (!el) return 'Sold out';
    try {
      var j = JSON.parse(el.textContent || '{}');
      return j.soldOut || 'Sold out';
    } catch (_e) {
      return 'Sold out';
    }
  }

  /**
   * Keep collection sort order; move sold-out products to the end of the full collection.
   */
  function sortCollectionWideLikePlp(products) {
    var avail = [];
    var sold = [];
    for (var i = 0; i < products.length; i++) {
      if (productAvailable(products[i])) avail.push(products[i]);
      else sold.push(products[i]);
    }
    return avail.concat(sold);
  }

  function cacheKey(handle, sortBy) {
    return CACHE_PREFIX + encodeURIComponent(handle) + ':' + encodeURIComponent(String(sortBy || ''));
  }

  function readCache(handle, sortBy) {
    try {
      var raw = sessionStorage.getItem(cacheKey(handle, sortBy));
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.t || !o.products) return null;
      if (Date.now() - o.t > CACHE_TTL_MS) return null;
      return o.products;
    } catch (_e) {
      return null;
    }
  }

  function writeCache(handle, sortBy, products) {
    try {
      sessionStorage.setItem(cacheKey(handle, sortBy), JSON.stringify({ t: Date.now(), products: products }));
    } catch (_e) {}
  }

  function compactProduct(p) {
    if (!p) return p;
    var imgs = p.images || [];
    var slimImgs = [];
    var i;
    for (i = 0; i < imgs.length && slimImgs.length < 2; i++) {
      var img = imgs[i];
      if (typeof img === 'string') slimImgs.push(img);
      else if (img && img.src) slimImgs.push({ src: img.src });
    }
    var vs = p.variants || [];
    var slimVs = [];
    for (i = 0; i < vs.length; i++) {
      var v = vs[i];
      slimVs.push({
        available: v.available,
        price: v.price,
        compare_at_price: v.compare_at_price,
        inventory_policy: v.inventory_policy,
        inventory_quantity: v.inventory_quantity,
        inventory_management: v.inventory_management,
      });
    }
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      vendor: p.vendor,
      tags: p.tags,
      available: p.available,
      variants: slimVs,
      images: slimImgs,
      featured_image: p.featured_image,
    };
  }

  function fetchCollectionProductsPage(handle, sortBy, page) {
    var url = collectionProductsJsonUrl(handle, JSON_LIMIT, page, sortBy);
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('products.json ' + r.status + ' ' + url);
      return r.json();
    }).then(function (data) {
      var list = data.products || [];
      var slim = [];
      for (var i = 0; i < list.length; i++) slim.push(compactProduct(list[i]));
      return slim;
    });
  }

  function fetchAllCollectionProducts(handle, sortBy, totalHint) {
    var cached = readCache(handle, sortBy);
    if (cached) return Promise.resolve(cached);

    var collected = [];

    function fetchNext(page) {
      if (collected.length >= MAX_CLIENT_FETCH_PRODUCTS) return Promise.resolve(collected);
      return fetchCollectionProductsPage(handle, sortBy, page).then(function (products) {
        collected = collected.concat(products);
        if (!products.length || products.length < JSON_LIMIT) return collected;
        return fetchNext(page + 1);
      });
    }

    return fetchNext(1).then(function (products) {
      writeCache(handle, sortBy, products);
      return products;
    });
  }

  function getPageFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var p = params.get('page');
      var n = parseInt(p || '1', 10);
      if (isNaN(n) || n < 1) return 1;
      return n;
    } catch (_e) {
      return 1;
    }
  }

  function replaceProtoIds(root, protoId, newId) {
    var a = String(protoId);
    var b = String(newId);
    if (a === b) return;
    root.querySelectorAll('[id]').forEach(function (el) {
      if (el.id.indexOf(a) !== -1) el.id = el.id.split(a).join(b);
    });
    ['aria-labelledby', 'for', 'aria-controls', 'data-modal', 'data-product-url', 'name'].forEach(function (attr) {
      root.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var v = el.getAttribute(attr);
        if (v && v.indexOf(a) !== -1) el.setAttribute(attr, v.split(a).join(b));
      });
    });
  }

  function updateProductLinks(root, handle) {
    var path = '/products/' + encodeURIComponent(handle);
    root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/products/') === -1) return;
      try {
        a.setAttribute('href', path + (href.indexOf('?') !== -1 ? href.slice(href.indexOf('?')) : ''));
      } catch (_e) {
        a.setAttribute('href', path);
      }
    });
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function exclusiveBrandLabel(vendorName, product) {
    var key = String(vendorName || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
    if (
      key === 'cop underdog' ||
      key === 'street junkies' ||
      key === 'lords and kings' ||
      key === 'lords & kings'
    ) {
      return 'Exclusive brand';
    }
    if (
      document.body &&
      (document.body.classList.contains('skipp-luxury-visual') ||
        document.body.classList.contains('luxury-mode'))
    ) {
      return 'Exclusive brand';
    }
    if (document.querySelector && document.querySelector('.modern-header--lux-only')) {
      return 'Exclusive brand';
    }
    var tags = (product && product.tags) || [];
    if (typeof tags === 'string') tags = tags.split(',');
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim().toLowerCase() === 'luxury') return 'Exclusive brand';
    }
    if (product && (product.template_suffix === 'luxury' || product.templateSuffix === 'luxury')) {
      return 'Exclusive brand';
    }
    return String(vendorName || '').trim();
  }

  function updateVendor(root, vendorName, product) {
    var wrap = root.querySelector('.card-vendor');
    if (!wrap) return;
    var v = exclusiveBrandLabel(vendorName, product);
    wrap.innerHTML =
      '<div class="card-vendor">' +
      '<span class="card-vendor__name">' +
      escapeHtml(v) +
      '</span></div>';
  }

  function updateTitle(root, title) {
    root.querySelectorAll('.card__heading a').forEach(function (el) {
      el.textContent = title;
    });
    var cover = root.querySelector('.skipp-card-full-cover-link .visually-hidden');
    if (cover) cover.textContent = title;
  }

  function updateWishlistButton(root, product) {
    var btn = root.querySelector('.product-wishlist');
    if (!btn || !product) return;
    var v = (product.variants && product.variants[0]) || {};
    var cents = toCents(v.price);
    var img = featuredImageUrl(product, 533);
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    btn.setAttribute('data-product-id', String(product.id));
    btn.setAttribute('data-product-handle', product.handle || '');
    btn.setAttribute('data-product-title', product.title || '');
    btn.setAttribute('data-product-vendor', product.vendor || '');
    btn.setAttribute('data-product-img', img);
    btn.setAttribute('data-product-price', '₹' + formatRs(cents));
    btn.setAttribute('data-product-url', '/products/' + encodeURIComponent(product.handle || ''));
    if (window.onhowWishlist && typeof window.onhowWishlist.syncButtonState === 'function') {
      window.onhowWishlist.syncButtonState(btn);
    }
  }

  function imageUrlWithWidth(url, width) {
    if (!url) return '';
    var normalized = String(url);
    if (normalized.indexOf('//') === 0) normalized = 'https:' + normalized;
    if (normalized.indexOf('width=') !== -1) return normalized;
    return normalized + (normalized.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  var CARD_IMAGE_WIDTHS = [165, 360, 533, 720, 940, 1066];
  var CARD_IMAGE_SIZES =
    '(min-width: 1600px) 342px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';

  function buildProductImageSrcset(url) {
    if (!url) return '';
    return CARD_IMAGE_WIDTHS.map(function (w) {
      return imageUrlWithWidth(url, w) + ' ' + w + 'w';
    }).join(', ');
  }

  function applyProductCardImages(img, url, lazy) {
    if (!img || !url) return;
    img.src = imageUrlWithWidth(url, 533);
    img.srcset = buildProductImageSrcset(url);
    img.sizes = CARD_IMAGE_SIZES;
    img.removeAttribute('width');
    img.removeAttribute('height');
    if (lazy) img.loading = 'lazy';
    img.hidden = false;
  }

  function featuredImageUrl(product, width) {
    var fi = product.featured_image;
    var url = '';
    if (typeof fi === 'string' && fi) url = fi;
    else if (fi && typeof fi === 'object' && fi.src) url = fi.src;
    else {
      var imgs = product.images;
      if (imgs && imgs.length) {
        var first = imgs[0];
        if (typeof first === 'string') url = first;
        else if (first && typeof first === 'object' && first.src) url = first.src;
      }
    }
    return imageUrlWithWidth(url, width || 720);
  }

  function normalizeImageSrc(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && value.src) return value.src;
    return '';
  }

  function secondaryImageUrl(product, width) {
    var featured = normalizeImageSrc(product.featured_image);
    var imgs = product.images || [];
    var featuredBase = featured ? featured.split('?')[0] : '';
    var i;
    var candidate = '';

    for (i = 0; i < imgs.length; i++) {
      var src = normalizeImageSrc(imgs[i]);
      if (!src) continue;
      if (featuredBase && src.split('?')[0] === featuredBase) continue;
      candidate = src;
      break;
    }

    return imageUrlWithWidth(candidate, width || 720);
  }

  function updateImages(root, product) {
    var url = featuredImageUrl(product, 533);
    var imgs = root.querySelectorAll('.card__media img');
    if (imgs[0] && url) {
      applyProductCardImages(imgs[0], url, false);
    }
    var sec = secondaryImageUrl(product, 533);
    if (imgs[1]) {
      if (sec) {
        applyProductCardImages(imgs[1], sec, true);
        imgs[1].style.removeProperty('display');
      } else {
        imgs[1].removeAttribute('src');
        imgs[1].removeAttribute('srcset');
        imgs[1].hidden = true;
      }
    }
  }

  function isSkippTagged(product, tagName) {
    var t = tagArray(product.tags);
    return t.indexOf(String(tagName || 'From_249').toLowerCase()) !== -1;
  }

  /**
   * Brand/vendor facet reload uses SSR cards (client-sort off). Remove Dawn's duplicate
   * .price__regular strip so compare-at only appears once inside .price__sale.
   */
  function fixDuplicateSalePrices(scope) {
    var root = scope || document;
    root.querySelectorAll('.product-card-wrapper .price.price--on-sale').forEach(function (priceEl) {
      var regular = priceEl.querySelector('.price__regular');
      if (regular) regular.remove();
    });
    root.querySelectorAll('.product-card-wrapper .card:not(.card--horizontal) .card__inner > .card__content').forEach(function (node) {
      node.remove();
    });
  }

  window.skippFixProductCardPrices = fixDuplicateSalePrices;

  function applyStandardPrice(root, product) {
    var v = (product.variants && product.variants[0]) || {};
    var cents = toCents(v.price);
    var compareCents = v.compare_at_price != null ? toCents(v.compare_at_price) : 0;
    var av = productAvailable(product);
    var priceEl = root.querySelector('.price');
    if (!priceEl) return;

    var sym = '₹';
    priceEl.classList.toggle('price--sold-out', !av);
    priceEl.classList.toggle('price--on-sale', av && compareCents > cents);

    if (!av) {
      priceEl.innerHTML =
        '<div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular">' +
        sym +
        formatRs(cents) +
        '</span></div></div>';
      return;
    }
    if (compareCents > cents) {
      priceEl.innerHTML =
        '<div class="price__container"><div class="price__sale"><span class="visually-hidden visually-hidden--inline">Sale price</span><span class="price-item price-item--sale price-item--last price-final">' +
        sym +
        formatRs(cents) +
        '</span><span><s class="price-item price-item--regular price-compare">' +
        sym +
        formatRs(compareCents) +
        '</s></span></div></div>';
      fixDuplicateSalePrices(root);
      return;
    }
    priceEl.innerHTML =
      '<div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular">' +
      sym +
      formatRs(cents) +
      '</span></div></div>';
  }

  function applySkippCardPrice(root, product, showSkipp, skippTag) {
    var priceBlock = root.querySelector('[data-skipp-card-price]');
    if (!priceBlock) {
      applyStandardPrice(root, product);
      return;
    }

    var v = (product.variants && product.variants[0]) || {};
    var cents = toCents(v.price);
    var compareCents = v.compare_at_price != null ? toCents(v.compare_at_price) : 0;
    var sym = '₹';

    var currentEl = priceBlock.querySelector('.skipp-card-price__current');
    var compareEl = priceBlock.querySelector('.skipp-card-price__compare');
    var discountEl = priceBlock.querySelector('.skipp-card-price__discount');
    var offerEl = priceBlock.querySelector('.skipp-card-offer');

    if (currentEl) currentEl.textContent = sym + formatRs(cents);

    if (compareEl) {
      if (productAvailable(product) && compareCents > cents) {
        compareEl.textContent = sym + formatRs(compareCents);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (discountEl) {
      if (productAvailable(product) && compareCents > cents) {
        var pct = Math.round(((compareCents - cents) * 100) / compareCents);
        discountEl.textContent = '(' + pct + '% OFF)';
        discountEl.setAttribute('aria-label', pct + ' percent off');
        discountEl.hidden = false;
      } else {
        discountEl.hidden = true;
      }
    }

    if (offerEl) {
      if (showSkipp && isSkippTagged(product, skippTag) && productAvailable(product)) {
        var skippCents = Math.max(0, cents - 20000);
        offerEl.textContent = 'Get it for ' + sym + formatRs(skippCents) + ' with coupon';
        offerEl.hidden = false;
      } else {
        offerEl.hidden = true;
      }
    }
  }

  function applyPricing(root, product, showSkipp, skippTag) {
    applySkippCardPrice(root, product, showSkipp, skippTag);
  }

  function applyCardBadge(root, product, soldClass) {
    var wraps = root.querySelectorAll('.card__badge');
    if (!wraps.length) return;

    var av = productAvailable(product);
    var scheme = soldClass || '';

    function setAllBadges(html) {
      for (var w = 0; w < wraps.length; w++) {
        wraps[w].innerHTML = html;
      }
    }

    if (!av) {
      setAllBadges(
        '<span class="badge badge--bottom-left ' + scheme + '">' + escapeHtml(soldOutLabel()) + '</span>'
      );
      return;
    }
    setAllBadges('');
  }

  function updateDiscountInline(root, product) {
    var priceRow = root.querySelector('.price-row');
    if (!priceRow) return;

    var tag = priceRow.querySelector('.discount-inline');
    var v = (product.variants && product.variants[0]) || {};
    var cents = toCents(v.price);
    var compareCents = v.compare_at_price != null ? toCents(v.compare_at_price) : 0;

    if (!productAvailable(product) || compareCents <= cents) {
      if (tag) tag.remove();
      return;
    }

    var pct = Math.round(((compareCents - cents) * 100) / compareCents);
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'discount-inline';
      priceRow.appendChild(tag);
    }
    tag.setAttribute('aria-label', pct + '% off');
    tag.textContent = '-' + pct + '%';
  }

  function applySoldOutVisuals(li, product) {
    var av = productAvailable(product);
    li.querySelectorAll('.card').forEach(function (card) {
      card.classList.toggle('card--sold-out', !av);
    });
    li.classList.toggle('grid__item--sold-out', !av);
    var wrap = li.querySelector('.card-wrapper, .product-card-wrapper');
    if (wrap) {
      wrap.classList.toggle('product-card-wrapper--sold-out', !av);
      wrap.setAttribute('data-skipp-in-stock', av ? 'true' : 'false');
    }
    li.querySelectorAll('.price').forEach(function (priceEl) {
      priceEl.classList.toggle('price--sold-out', !av);
    });
  }

  function buildLiFromProduct(product, protoTemplate, protoId, cfg) {
    var node = protoTemplate.content.cloneNode(true);
    var li = node.querySelector('li.grid__item');
    if (!li) return null;

    var tagsStr = Array.isArray(product.tags) ? product.tags.join(',') : String(product.tags || '');
    li.setAttribute('data-product-id', product.id);
    li.setAttribute('data-skipp-product-title', product.title || '');
    li.setAttribute('data-skipp-tags', tagsStr);

    replaceProtoIds(li, protoId, product.id);
    updateProductLinks(li, product.handle);
    updateTitle(li, product.title || '');
    updateVendor(li, product.vendor, product);
    updateImages(li, product);
    updateWishlistButton(li, product);

    applyPricing(li, product, cfg.showSkipp, cfg.skippTag);
    applyCardBadge(li, product, cfg.soldBadgeClass);

    var tagWrap = li.querySelector('.card-wrapper[data-skipp-tags]');
    if (tagWrap) tagWrap.setAttribute('data-skipp-tags', tagsStr);

    applySoldOutVisuals(li, product);

    return li;
  }

  function updateMeta(rootEl, start, end, total) {
    var rangeEl = rootEl.querySelector('[data-skipp-plp-range]');
    if (!rangeEl) return;
    if (total === 0) {
      rangeEl.textContent = '';
      rangeEl.hidden = true;
      return;
    }
    rangeEl.hidden = false;
    rangeEl.textContent = 'Showing ' + start + '–' + end + ' of ' + total + ' products';
  }

  function buildPaginationItems(curPage, pages) {
    if (pages <= 7) {
      var all = [];
      for (var i = 1; i <= pages; i++) all.push(i);
      return all;
    }

    var items = [];
    var tailStart = pages - 2;

    if (curPage <= 4) {
      for (var a = 1; a <= 5; a++) items.push(a);
      if (tailStart > 6) {
        items.push('ellipsis');
        for (var b = tailStart; b <= pages; b++) items.push(b);
      } else {
        for (var c = 6; c <= pages; c++) items.push(c);
      }
      return items;
    }

    if (curPage >= pages - 3) {
      items.push(1);
      items.push('ellipsis');
      for (var d = pages - 4; d <= pages; d++) items.push(d);
      return items;
    }

    items.push(1);
    items.push('ellipsis');
    for (var e = curPage - 1; e <= curPage + 1; e++) items.push(e);
    items.push('ellipsis');
    for (var f = tailStart; f <= pages; f++) items.push(f);
    return items;
  }

  function rebuildPagination(navInner, total, perPage) {
    if (!navInner) return;

    var pages = Math.max(1, Math.ceil(total / perPage));
    var curPage = getPageFromUrl();
    if (curPage > pages) curPage = pages;

    function hrefFor(p) {
      var q = new URLSearchParams(window.location.search);
      q.delete('skipp_page');
      if (p <= 1) q.delete('page');
      else q.set('page', String(p));
      var s = q.toString();
      return window.location.pathname + (s ? '?' + s : '') + window.location.hash;
    }

    if (pages <= 1) {
      navInner.innerHTML = '';
      return;
    }

    var html =
      '<div class="pagination-wrapper" data-page="' +
      curPage +
      '"><nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';

    if (curPage > 1) {
      html +=
        '<li><a href="' +
        escapeHtml(hrefFor(curPage - 1)) +
        '" class="pagination__item pagination__item-arrow pagination__item--arrow-prev link motion-reduce" rel="prev" aria-label="Previous"><span class="pagination__item-arrow__glyph" aria-hidden="true">&lsaquo;</span></a></li>';
    }

    var pageItems = buildPaginationItems(curPage, pages);

    pageItems.forEach(function (item) {
      if (item === 'ellipsis') {
        html += '<li><span class="pagination__item pagination__item--ellipsis" aria-hidden="true">&hellip;</span></li>';
        return;
      }
      if (item === curPage) {
        html +=
          '<li><span class="pagination__item pagination__item--current" aria-current="page">' +
          item +
          '</span></li>';
      } else {
        html +=
          '<li><a href="' +
          escapeHtml(hrefFor(item)) +
          '" class="pagination__item link" aria-label="Page ' +
          item +
          '">' +
          item +
          '</a></li>';
      }
    });

    if (curPage < pages) {
      html +=
        '<li><a href="' +
        escapeHtml(hrefFor(curPage + 1)) +
        '" class="pagination__item pagination__item-arrow pagination__item--arrow-next link motion-reduce" rel="next" aria-label="Next"><span class="pagination__item-arrow__glyph" aria-hidden="true">&rsaquo;</span></a></li>';
    }

    html += '</ul></nav></div>';
    navInner.innerHTML = html;
  }

  /**
   * Delivery split observes #product-grid childList — removing each <li> one-by-one runs redistribute
   * while express/next are empty → both sections get hidden=true and can stay broken. Batch clears/appends.
   */
  function clearPlpGridFully(staging) {
    if (!staging) return;
    staging.querySelectorAll(':scope > li.grid__item').forEach(function (li) {
      li.remove();
    });
  }

  function appendSliceToStaging(staging, slice, proto, protoId, cfg) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < slice.length; i++) {
      var li = buildLiFromProduct(slice[i], proto, protoId, cfg.cardCfg);
      if (!li) continue;
      if (cfg.animationsReveal && slice.length > 2 && i >= 2) {
        li.querySelectorAll('.card__media img').forEach(function (img) {
          img.loading = 'lazy';
        });
      }
      frag.appendChild(li);
    }
    staging.appendChild(frag);
  }

  function tryApplyPageOnly(cfg) {
    var list = cfg.wrap._skippSortedProducts;
    var handle = cfg.wrap.getAttribute('data-skipp-plp-collection-handle') || '';
    var sortBy = cfg.wrap.getAttribute('data-skipp-plp-sort-by') || '';
    if (!list || !list.length || cfg.wrap._skippSortedHandle !== handle || cfg.wrap._skippSortedSortBy !== sortBy) {
      return false;
    }

    var staging = document.getElementById('product-grid');
    var proto = cfg.wrap._skippProtoTemplate || document.getElementById('skipp-plp-row-proto-' + cfg.sectionId);
    if (!staging || !proto) return false;

    var protoId = proto.getAttribute('data-skipp-plp-proto-product-id');
    if (!protoId) return false;

    var page = getPageFromUrl();
    var pages = Math.max(1, Math.ceil(list.length / cfg.perPage));
    if (page > pages) page = pages;
    var startIdx = (page - 1) * cfg.perPage;
    var slice = list.slice(startIdx, startIdx + cfg.perPage);

    clearPlpGridFully(staging);

    appendSliceToStaging(staging, slice, proto, protoId, cfg);

    var total = list.length;
    var lo = total === 0 ? 0 : startIdx + 1;
    var hi = Math.min(startIdx + cfg.perPage, total);
    updateMeta(cfg.wrap, lo, hi, total);

    var navInner = cfg.paginationInner;
    rebuildPagination(navInner, total, cfg.perPage);

    if (typeof window.refreshSkippDeliveryBadges === 'function') {
      window.refreshSkippDeliveryBadges(staging);
    }
    document.dispatchEvent(new CustomEvent('skipp:user-location-changed'));
    return true;
  }

  function shouldRunPlpClientSort(wrap) {
    if (!wrap || wrap.getAttribute('data-skipp-plp-client-sort') !== 'true') return false;
    if (wrap.getAttribute('data-skipp-plp-ssr-sorted') === 'true') return false;
    return true;
  }

  /** True when storefront filters are in the URL — keep SSR grid from facet AJAX. */
  function hasActivePlpServerState(wrap) {
    try {
      var params = new URLSearchParams(window.location.search);
      var keys = Array.from(params.keys());
      for (var i = 0; i < keys.length; i++) {
        if (String(keys[i]).indexOf('filter.') === 0) return true;
      }
    } catch (_e) {}
    return false;
  }

  function shouldSkipClientSortReinit(wrap) {
    if (!wrap || !shouldRunPlpClientSort(wrap)) return true;
    if (hasActivePlpServerState(wrap)) return true;
    return false;
  }

  /** Invalidate in-flight products.json fetch so facet SSR results are not overwritten. */
  function cancelPlpClientSort(wrap) {
    if (!wrap) return;
    wrap._skippPlpRunGen = (wrap._skippPlpRunGen || 0) + 1;
    delete wrap.dataset.skippPlpSortInFlight;
    delete wrap._skippSortedProducts;
    delete wrap._skippSortedHandle;
    delete wrap._skippSortedSortBy;
    delete wrap._skippProtoTemplate;
  }

  function run(cfg) {
    if (!cfg || !cfg.wrap) return;
    if (!shouldRunPlpClientSort(cfg.wrap)) {
      cancelPlpClientSort(cfg.wrap);
      return;
    }
    if (cfg.wrap.dataset.skippPlpSortInFlight === '1') return;
    cfg.wrap.dataset.skippPlpSortInFlight = '1';
    var runGen = (cfg.wrap._skippPlpRunGen = (cfg.wrap._skippPlpRunGen || 0) + 1);

    var staging = document.getElementById('product-grid');
    var proto = document.getElementById('skipp-plp-row-proto-' + cfg.sectionId);
    var handle = cfg.wrap.getAttribute('data-skipp-plp-collection-handle') || '';
    var sortBy = cfg.wrap.getAttribute('data-skipp-plp-sort-by') || '';
    var totalHint = cfg.wrap.getAttribute('data-skipp-plp-product-count') || '';

    if (!staging || !proto || !handle) {
      delete cfg.wrap.dataset.skippPlpSortInFlight;
      return;
    }

    var hasSsrItems = !!staging.querySelector(':scope > li.grid__item');
    if (hasSsrItems) {
      cfg.wrap.setAttribute('data-skipp-plp-sort-ready', '1');
    } else {
      var collectionEl = cfg.wrap.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading', 'skipp-plp-client-sort-pending');
      cfg.wrap.classList.add('skipp-plp-grid-loading');
    }

    cfg.wrap._skippProtoTemplate = proto;

    var protoId = proto.getAttribute('data-skipp-plp-proto-product-id');
    if (!protoId) {
      delete cfg.wrap.dataset.skippPlpSortInFlight;
      return;
    }

    function finishRun() {
      if (runGen !== cfg.wrap._skippPlpRunGen) return;
      delete cfg.wrap.dataset.skippPlpSortInFlight;
      cfg.wrap.setAttribute('data-skipp-plp-sort-ready', '1');
      if (cfg.wrap._skippSortedProducts && cfg.wrap._skippSortedProducts.length) {
        cfg.wrap.setAttribute('data-skipp-plp-soldout-applied', '1');
      }
      var collectionElDone = cfg.wrap.querySelector('.collection');
      if (collectionElDone) {
        collectionElDone.classList.remove('loading', 'skipp-plp-client-sort-pending');
      }
      cfg.wrap.classList.remove('skipp-plp-grid-loading', 'skipp-plp-grid-updating');
    }

    function applySortedProducts(products) {
      if (!shouldRunPlpClientSort(cfg.wrap) || runGen !== cfg.wrap._skippPlpRunGen) return;
      var sorted = sortCollectionWideLikePlp(products || []);
      if (!sorted.length) return;
      cfg.wrap._skippSortedProducts = sorted;
      cfg.wrap._skippSortedHandle = handle;
      cfg.wrap._skippSortedSortBy = sortBy;

      var currentPage = getPageFromUrl();
      var pages = Math.max(1, Math.ceil(sorted.length / cfg.perPage));
      if (currentPage > pages) currentPage = pages;
      var startIdx = (currentPage - 1) * cfg.perPage;
      var slice = sorted.slice(startIdx, startIdx + cfg.perPage);

      clearPlpGridFully(staging);
      appendSliceToStaging(staging, slice, proto, protoId, cfg);
      cfg.wrap.setAttribute('data-skipp-plp-sort-ready', '1');
      cfg.wrap.setAttribute('data-skipp-plp-soldout-applied', '1');
      var total = sorted.length;
      var lo = total === 0 ? 0 : startIdx + 1;
      var hi = Math.min(startIdx + cfg.perPage, total);
      updateMeta(cfg.wrap, lo, hi, total);
      if (typeof window.refreshSkippDeliveryBadges === 'function') {
        window.refreshSkippDeliveryBadges(staging);
      }
      document.dispatchEvent(new CustomEvent('skipp:user-location-changed'));

      rebuildPagination(cfg.paginationInner, sorted.length, cfg.perPage);
    }

    function startFetch() {
      fetchAllCollectionProducts(handle, sortBy, totalHint)
        .then(applySortedProducts)
        .catch(function () {
          if (runGen !== cfg.wrap._skippPlpRunGen) return;
          runHtmlSoldOutLast(cfg.wrap, true);
        })
        .finally(finishRun);
    }

    startFetch();
  }

  function findCfg(wrap) {
    var sid = wrap.getAttribute('data-skipp-plp-section-id') || '';
    var perPage = parseInt(wrap.getAttribute('data-skipp-plp-per-page') || '24', 10) || 24;
    var paginationInner = wrap.querySelector('[data-skipp-plp-pagination-inner]');

    return {
      wrap: wrap,
      sectionId: sid,
      perPage: perPage,
      paginationInner: paginationInner,
      animationsReveal: wrap.getAttribute('data-skipp-plp-animations') === 'true',
      cardCfg: {
        skippTag: wrap.getAttribute('data-skipp-plp-skipp-tag') || 'From_249',
        showSkipp: wrap.getAttribute('data-skipp-plp-show-skipp-price') === 'true',
        soldBadgeClass: wrap.getAttribute('data-skipp-plp-sold-badge-class') || '',
        saleBadgeClass: wrap.getAttribute('data-skipp-plp-sale-badge-class') || '',
      },
    };
  }

  function bindPaginationDelegation(root, cfgFactory) {
    if (root.dataset.skippPlpPaginationBound === '1') return;
    root.dataset.skippPlpPaginationBound = '1';

    root.addEventListener('click', function (e) {
      var pagRoot = e.target.closest('[data-skipp-plp-pagination]');
      if (!pagRoot || !root.contains(pagRoot)) return;

      var a = e.target.closest('a.pagination__item[href]');
      if (!a || !pagRoot.contains(a)) return;
      if (e.defaultPrevented) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (typeof e.button === 'number' && e.button !== 0) return;

      var href = a.getAttribute('href');
      if (!href || href === '#' || href.indexOf('javascript:') === 0) return;

      var cfg = cfgFactory();
      if (!cfg || (!cfg.wrap._skippSortedProducts && !cfg.wrap._skippSortedHtmlItems)) return;

      e.preventDefault();
      root.dataset.skippPlpScrollAfterPagination = '1';

      var linkUrl;
      try {
        linkUrl = new URL(href, window.location.href);
        history.pushState({ skippPlp: true }, '', linkUrl.pathname + linkUrl.search + linkUrl.hash);
      } catch (_e) {
        window.location.href = href;
        return;
      }

      if (tryApplyPageOnly(cfg)) {
        scrollGridIntoView(root);
      } else if (tryApplyHtmlPageOnly(cfg.wrap)) {
        scrollGridIntoView(root);
      } else {
        window.location.href = linkUrl.href;
      }
    });
  }

  function scrollGridIntoView(root) {
    if (root.dataset.skippPlpScrollAfterPagination !== '1') return;
    delete root.dataset.skippPlpScrollAfterPagination;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var el = document.getElementById('ProductGridContainer');
        if (!el) return;
        try {
          el.scrollIntoView({ block: 'start', behavior: 'smooth' });
        } catch (_e) {
          try {
            el.scrollIntoView(true);
          } catch (_e2) {}
        }
      });
    });
  }

  function reinitWrap(wrap) {
    if (!wrap) return;
    if (!shouldRunPlpClientSort(wrap)) {
      cancelPlpClientSort(wrap);
      return;
    }

    wrap._skippPlpRunGen = (wrap._skippPlpRunGen || 0) + 1;
    delete wrap._skippSortedProducts;
    delete wrap._skippSortedHandle;
    delete wrap._skippSortedSortBy;
    delete wrap._skippProtoTemplate;
    delete wrap.dataset.skippPlpSortInFlight;

    bindPaginationDelegation(wrap, function () { return findCfg(wrap); });
    run(findCfg(wrap));
  }

  function syncProductGridContainerAttrs(local, remote) {
    if (!local || !remote) return;
    [
      'data-skipp-plp-client-sort',
      'data-skipp-plp-collection-handle',
      'data-skipp-plp-product-count',
      'data-skipp-plp-section-id',
      'data-skipp-plp-per-page',
      'data-skipp-plp-sort-by',
      'data-skipp-plp-default-sort-by',
      'data-skipp-plp-animations',
      'data-skipp-plp-show-skipp-price',
      'data-skipp-plp-skipp-tag',
      'data-skipp-plp-sold-badge-class',
      'data-skipp-plp-sale-badge-class',
      'data-skipp-plp-sort-ready',
      'data-skipp-plp-soldout-applied',
    ].forEach(function (name) {
      if (remote.hasAttribute(name)) {
        local.setAttribute(name, remote.getAttribute(name));
      } else {
        local.removeAttribute(name);
      }
    });
  }

  function patchFacetProductGridRerender() {
    var FF = window.FacetFiltersForm;
    if (!FF || typeof FF.renderProductGridContainer !== 'function' || FF._skippPlpClientSortPatched) return;
    FF._skippPlpClientSortPatched = true;
    var orig = FF.renderProductGridContainer.bind(FF);
    FF.renderProductGridContainer = function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var remote = parsed.getElementById('ProductGridContainer');
      var local = document.getElementById('ProductGridContainer');
      if (local) {
        local._skippPlpRunGen = (local._skippPlpRunGen || 0) + 1;
        delete local.dataset.skippPlpSortInFlight;
      }
      syncProductGridContainerAttrs(local, remote);
      orig(html);
      queueMicrotask(function () {
        var container = document.getElementById('ProductGridContainer');
        fixDuplicateSalePrices(container || document);
        if (shouldSkipClientSortReinit(container)) {
          cancelPlpClientSort(container);
          return;
        }
        reinitWrap(container);
      });
    };
  }

  function gridItemIsSoldOut(li) {
    if (!li) return false;
    if (li.getAttribute('data-available') === 'false') return true;
    if (li.querySelector('[data-skipp-in-stock="false"]')) return true;
    return !!li.querySelector('.card--sold-out');
  }

  function sortDomItemsSoldOutLast(items) {
    var avail = [];
    var sold = [];
    (items || []).forEach(function (li) {
      if (gridItemIsSoldOut(li)) sold.push(li);
      else avail.push(li);
    });
    return avail.concat(sold);
  }

  function fetchPlpSectionPage(sectionId, page) {
    var url = new URL(window.location.href);
    if (page <= 1) url.searchParams.delete('page');
    else url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);
    return fetch(url.pathname + '?' + url.searchParams.toString(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('section ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.from(doc.querySelectorAll('#product-grid > li.grid__item'));
    });
  }

  function applyHtmlSortedItems(wrap, items) {
    var grid = wrap.querySelector('#product-grid');
    if (!grid) return;
    var perPage = parseInt(wrap.getAttribute('data-skipp-plp-per-page') || '24', 10) || 24;
    wrap._skippSortedHtmlItems = items;
    var page = getPageFromUrl();
    var pages = Math.max(1, Math.ceil(items.length / perPage));
    if (page > pages) page = pages;
    var start = (page - 1) * perPage;
    var slice = items.slice(start, start + perPage);
    grid.innerHTML = '';
    var frag = document.createDocumentFragment();
    slice.forEach(function (li) {
      frag.appendChild(li);
    });
    grid.appendChild(frag);
    wrap.setAttribute('data-skipp-plp-soldout-applied', '1');
    rebuildPagination(wrap.querySelector('[data-skipp-plp-pagination-inner]'), items.length, perPage);
    if (typeof window.refreshSkippDeliveryBadges === 'function') {
      window.refreshSkippDeliveryBadges(grid);
    }
  }

  function tryApplyHtmlPageOnly(wrap) {
    if (!wrap || !wrap._skippSortedHtmlItems || !wrap._skippSortedHtmlItems.length) return false;
    applyHtmlSortedItems(wrap, wrap._skippSortedHtmlItems);
    return true;
  }

  function runHtmlSoldOutLast(wrap, force) {
    if (!wrap || wrap.getAttribute('data-skipp-plp-soldout-last') !== 'true') return;
    if (!force && shouldRunPlpClientSort(wrap)) return;
    if (wrap.dataset.skippPlpHtmlSortInFlight === '1') return;
    var grid = wrap.querySelector('#product-grid');
    var sectionId = wrap.getAttribute('data-skipp-plp-section-id') || (grid && grid.getAttribute('data-id'));
    var pagesHint = parseInt(wrap.getAttribute('data-skipp-plp-paginate-pages') || '1', 10) || 1;
    if (!grid || !sectionId) return;

    var currentPage = getPageFromUrl();
    var firstItems = Array.from(grid.querySelectorAll(':scope > li.grid__item'));
    if (!firstItems.length) return;

    wrap.dataset.skippPlpHtmlSortInFlight = '1';

    function fetchPage(pageNum) {
      return fetchPlpSectionPage(sectionId, pageNum).then(function (list) {
        return { page: pageNum, list: list || [] };
      });
    }

    var fetches = [];
    var p;
    for (p = 1; p <= pagesHint && p <= 40; p++) {
      if (p === currentPage) continue;
      fetches.push(fetchPage(p));
    }

    Promise.all(fetches)
      .then(function (pages) {
        var byPage = {};
        byPage[currentPage] = firstItems;
        pages.forEach(function (entry) {
          byPage[entry.page] = entry.list;
        });
        var all = [];
        var i;
        for (i = 1; i <= pagesHint; i++) {
          (byPage[i] || []).forEach(function (li) {
            all.push(li);
          });
        }
        applyHtmlSortedItems(wrap, sortDomItemsSoldOutLast(all));
        bindPaginationDelegation(wrap, function () {
          return findCfg(wrap);
        });
      })
      .catch(function () {
        applyHtmlSortedItems(wrap, sortDomItemsSoldOutLast(firstItems));
      })
      .finally(function () {
        delete wrap.dataset.skippPlpHtmlSortInFlight;
      });
  }

  function init() {
    patchFacetProductGridRerender();
    fixDuplicateSalePrices(document.getElementById('product-grid') || document);
    document.querySelectorAll('[data-skipp-plp-client-sort="true"]').forEach(function (wrap) {
      var cfgFactory = function () { return findCfg(wrap); };
      bindPaginationDelegation(wrap, cfgFactory);
      run(findCfg(wrap));
    });
    document.querySelectorAll('[data-skipp-plp-soldout-last="true"]').forEach(function (wrap) {
      runHtmlSoldOutLast(wrap);
    });
  }

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-skipp-plp-client-sort="true"], [data-skipp-plp-soldout-last="true"]').forEach(function (wrap) {
      wrap.dataset.skippPlpScrollAfterPagination = '1';
      var cfg = findCfg(wrap);
      if (tryApplyPageOnly(cfg) || tryApplyHtmlPageOnly(wrap)) scrollGridIntoView(wrap);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target) return;
    patchFacetProductGridRerender();
    ev.target.querySelectorAll('[data-skipp-plp-client-sort="true"]').forEach(function (wrap) {
      reinitWrap(wrap);
    });
  });
})();
